<template>
    <v-container>
        <thumbnail v-for="company in companiesDisplayed" :key="company['_id']" :companyDetails="company" :addAliasButton="addAlias" @emitAddAliasEvent="emitAddAliasEvent"/>
    </v-container>
</template>

<script>
import thumbnail from '@/components/Thumbnail';

export default {
    props: {
        "companiesDisplayed": Array,
        "addAlias": Boolean,
    }, 

    components: {
        thumbnail,
    },

    methods: {
        emitAddAliasEvent(payload) {
            console.log("emit event from results");
            this.$emit("emitAddAliasEvent", payload)
        },
    },
}
</script>